import { jsx, jsxs } from "react/jsx-runtime";
import clsx from "clsx";
import { createContext, useState, useContext, useEffect, useSyncExternalStore } from "react";
import { Toaster } from "./components/ui/sonner.js";
import { createPortal } from "react-dom";
import { GlobalDirtyStateProvider } from "./hooks/use-global-dirty-state.js";
import Icon from "./components/ui/icon.js";
const ShadeContext = createContext({
  isAnyTextFieldFocused: false,
  setFocusState: () => {
  },
  // fetchKoenigLexical: async () => {},
  darkMode: false
});
const useShade = () => useContext(ShadeContext);
const useFocusContext = () => {
  const context = useShade();
  if (!context) {
    throw new Error("useFocusContext must be used within a FocusProvider");
  }
  return context;
};
const ToasterPortal = () => {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);
  return mounted ? createPortal(
    /* @__PURE__ */ jsx("div", { className: SHADE_APP_NAMESPACES, style: { width: "unset", height: "unset" }, children: /* @__PURE__ */ jsx(
      Toaster,
      {
        icons: {
          error: /* @__PURE__ */ jsx(Icon.ErrorFill, { className: "text-red" }),
          success: /* @__PURE__ */ jsx(Icon.SuccessFill, { className: "text-green" }),
          info: /* @__PURE__ */ jsx(Icon.InfoFill, { className: "text-text-tertiary" })
        },
        position: "bottom-left",
        toastOptions: {
          classNames: {
            title: "mt-[-1px]! text-md! font-semibold! leading-tighter! tracking-[0.1px]!",
            description: "text-text-primary! text-sm! mt-px!",
            icon: "ml-0!"
          },
          style: {
            alignItems: "flex-start",
            maxWidth: "290px"
          }
        }
      }
    ) }),
    document.body
  ) : null;
};
const ShadeProvider = ({ darkMode, children }) => {
  const [isAnyTextFieldFocused, setIsAnyTextFieldFocused] = useState(false);
  const setFocusState = (value) => {
    setIsAnyTextFieldFocused(value);
  };
  return /* @__PURE__ */ jsx(ShadeContext.Provider, { value: { isAnyTextFieldFocused, setFocusState, darkMode }, children: /* @__PURE__ */ jsxs(GlobalDirtyStateProvider, { children: [
    children,
    /* @__PURE__ */ jsx(ToasterPortal, {})
  ] }) });
};
const SHADE_APP_NAMESPACES = "shade shade-admin shade-activitypub shade-stats shade-posts";
function getSnapshot() {
  return document.documentElement.classList.contains("dark");
}
function subscribe(callback) {
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.attributeName === "class") {
        callback();
      }
    }
  });
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ["class"]
  });
  return () => observer.disconnect();
}
function useDarkMode() {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}
const ShadeApp = ({ darkMode: _darkModeProp, fetchKoenigLexical, className, children, ...props }) => {
  const darkMode = useDarkMode();
  const appClassName = clsx(
    "shade",
    darkMode && "dark",
    className
  );
  return /* @__PURE__ */ jsx("div", { className: appClassName, ...props, children: /* @__PURE__ */ jsx(ShadeProvider, { darkMode, children }) });
};
export {
  SHADE_APP_NAMESPACES as S,
  ShadeApp as a,
  ShadeProvider as b,
  useShade as c,
  useFocusContext as u
};
//# sourceMappingURL=shade-app-Dj6sDEso.js.map
